// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 页面类型枚举 枚举类
 * 页面类型枚举
 */
export enum EnumPageType {
  /** 实体页面 : 实体页面 */
  Entity = 1,
  /** 服务操作页面 : 服务操作页面 */
  ServiceAction = 2,
  /** 自定义页面 : 自定义页面 */
  Custom = 4
}

/**
 * 页面类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumPageTypeMD {
  private static items = [
    new EnumItemMD('Entity', 1, '实体页面', '实体页面'),
    new EnumItemMD('ServiceAction', 2, '服务操作页面', '服务操作页面'),
    new EnumItemMD('Custom', 4, '自定义页面', '自定义页面')
  ];

  static getItem(enumItem: EnumPageType) {
    return this.items.find(item => item.name === EnumPageType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
